// Amplitude analytics DESABILITADO - nenhum dado e enviado externamente

export class AnalyticsHelper {
  constructor() {
    this.analytics = null;
    this.user = {};
  }

  async init() {}
  identify() {}
  track() {}
  page() {}
}

export default new AnalyticsHelper();
